import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import { useOpenBalancePage } from "../hooks/useOpenBalancePage";
/**
 * Context for the OpenBalance page, providing access to the OpenBalancePage hook.
 */
const OpenBalanceContext = createContext(null);
/**
 * Provider component for the OpenBalance context.
 * @param children - The child components to be rendered within the provider.
 * @returns The OpenBalanceProvider component.
 */
export const OpenBalanceProvider = ({ children }) => {
    const OBP = useOpenBalancePage();
    return _jsx(OpenBalanceContext.Provider, Object.assign({ value: OBP }, { children: children }));
};
/**
 * Custom hook to use the OpenBalance context.
 * @returns The OpenBalance context value.
 * @throws An error if used outside of an OpenBalanceProvider.
 */
export const useOpenBalanceContext = () => {
    const context = useContext(OpenBalanceContext);
    if (!context) {
        throw new Error("useOpenBalance must be used within an OpenBalanceProvider");
    }
    return context;
};
